import React from 'react'
import FormArmoire from '../../../Components/FormArmoire'

const AjouterArmoire = () => {
  return <FormArmoire />
}

export default AjouterArmoire
